import { JSX, ReactNode, useEffect, useRef } from "react";
import "./feadtoggle.scss";

export interface IFeadToggle {
  text: string;
  styles?: string;
  btnStyles?: string;
  minHeight?: number;
  maxHeight?: number;
  desc?: JSX.Element;
  children: ReactNode;
}
export default function FeadToggle({
  text,
  styles,
  btnStyles,
  maxHeight,
  desc,
  children,
}: IFeadToggle) {
  const toggleRef = useRef<HTMLDivElement>(null);
  const listRef = useRef<HTMLDivElement>(null);

  const handleToggle = () => {
    if (listRef.current) {
      const clssList = listRef.current.className;
      if (clssList.includes("visible")) {
        listRef.current.style.height = 0 + "px";
        listRef.current.classList.remove("visible");
      }
      if (!clssList.includes("visible")) {
        listRef.current.style.height = maxHeight + "px";
        listRef.current.classList.add("transition-25");
        listRef.current.classList.add("visible");
      }
    }
  };

  useEffect(() => {
    if (listRef.current) {
      listRef.current.style.height = "0px";
    }
  }, []);

  return (
    <div className={"fead-toggle" + " " + styles} ref={toggleRef}>
      <div className="transition-25" onClick={handleToggle}>
        <button className={btnStyles}>{text}</button>
        {desc}
      </div>
      <div ref={listRef}>{children}</div>
    </div>
  );
}
